import styled from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScHowToParticipateSection = styled.div`
  margin-top: 40px;

  @media (${device.mobile}) {
    margin-top: 8px;
  }

  & > .cards {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 64px;
    margin-left: 48px;

    @media (${device.mobile}) {
      flex-direction: column;
      gap: 16px;
    }
  }
`;

export const ScHowToParticipateSectionTitle = styled.h2`
  ${typography['headline2']}
  text-align: center;
  color: ${({ theme }) => theme.whiteColor};
  margin-bottom: 24px;
  text-transform: uppercase;

  @media (${device.mobile}) {
    ${typography['headline2mobile']}
  }
`;

export const ScHowToParticipateSectionCard = styled.div`
  position: relative;
  width: 100%;
  padding: 24px 24px 24px 40px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.grayDarkColor};

  & > .image {
    position: absolute;
    top: 50%;
    left: -48px;
    transform: translateY(-50%);
  }

  & > .title {
    ${typography['body1bold']}
    color: ${({ theme }) => theme.whiteColor};
    margin-bottom: 8px;
  }

  & > .description {
    ${typography['body1regular']}
    font-weight: 400;
    letter-spacing: 0em;
    color: ${({ theme }) => theme.manateeColor};
  }
`;
